// extracted by mini-css-extract-plugin
module.exports = {"default-background":"styles-module__default-background___2yxrU","responsive-image":"styles-module__responsive-image___9G2LW"};